<template>
  <v-dialog persistent v-model="dialog" max-width="600">
    <v-card v-if="doc">
      <v-card-title>
        {{ titulo }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-combobox
          v-model="tipoDocumento"
          item-value="id"
          placeholder="Tipo de documento"
          :items="tiposPermitidos"
          :disabled="doc.id !== 0"
        >
          <template v-slot:selection="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.descricao }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ strTipos(item) }} -
                {{ tamanhoMaximo(item) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.descricao }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ strTipos(item) }} -
                {{ tamanhoMaximo(item) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-combobox>
        <template v-if="tipoDocumento">
          <v-file-input
            v-model="arquivo"
            v-if="!doc.id"
            label="Arquivo"
            clearable
            :accept="mimeTypes"
            show-size
            :error-messages="arquivoErrors"
          />
          <template
            v-if="(!doc.id && arquivo && arquivoErrors.length === 0) || doc.id"
          >
            <v-text-field
              v-model="arquivoNome"
              label="Nome do arquivo"
              :suffix="arquivoExtensao"
              :counter="arquivoMaxLength"
              :maxlength="arquivoMaxLength"
            />
            <v-text-field
              v-model="doc.registro"
              label="Registro"
              counter="50"
              maxlength="50"
              hint="Identificação do documento (Nº do CPF/CNPJ, identificação de contratos, etc)"
              persistent-hint
            />
            <v-menu
              v-model="menuDataValidade"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataValidade"
                  label="Data de validade"
                  prepend-icon="mdi mdi-calendar"
                  readonly
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <button-datepicker
                v-model="doc.data_validade"
                @input="menuDataValidade = false"
              />
            </v-menu>
          </template>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn
          class="primary"
          depressed
          :disabled="disabled"
          @click="salvar()"
          >{{ tituloBotao }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import ButtonDatepicker from "../ButtonDatepicker";
export default {
  components: { ButtonDatepicker },
  props: ["urlBase"],
  data() {
    return {
      loading: false,
      tipoDocumento: null,
      arquivo: null,
      menuDataValidade: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.documento.docAtivo;
      },
      set(open) {
        if (!open) {
          this.tipoDocumento = null;
          this.arquivo = null;
          this.$store.commit("documento/limparAtivo");
        }
      },
    },
    titulo() {
      return this.doc.id ? "Editar documento" : "Novo documento";
    },
    tituloBotao() {
      return this.doc.id ? "Editar" : "Adicionar";
    },
    mimeTypes() {
      const tipos = [];
      for (let t of this.tipoDocumento.tipos_permitidos) {
        switch (t) {
          case "imagem":
            tipos.push("image/*");
            break;
          case "audio":
            tipos.push("audio/mpeg");
            break;
          case "pdf":
            tipos.push("application/pdf");
            break;
          case "word":
            tipos.push(
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            );
            break;
          case "excel":
            tipos.push(
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
            break;
        }
      }
      return tipos.join(",");
    },
    arquivoErrors() {
      const errors = [];
      if (!this.arquivo) {
        return errors;
      }

      if (this.arquivo.size / 1024 / 1024 > this.tipoDocumento.tamanho_maximo) {
        errors.push("Tamanho de arquivo é maior que o máximo permitido");
      }

      let tipo = "";
      if (this.arquivo.type.substr(0, 5) === "image") {
        tipo = "imagem";
      } else if (this.arquivo.type === "audio/mpeg") {
        tipo = "audio";
      } else if (this.arquivo.type === "application/pdf") {
        tipo = "pdf";
      } else if (
        this.arquivo.type === "application/msword" ||
        this.arquivo.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        tipo = "word";
      } else if (
        this.arquivo.type === "application/vnd.ms-excel" ||
        this.arquivo.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        tipo = "excel";
      }

      if (!this.tipoDocumento.tipos_permitidos.includes(tipo)) {
        errors.push("Tipo de arquivo inválido");
      }

      return errors;
    },
    arquivoExtensao() {
      return "." + this.doc.nome_original.split(".").pop();
    },
    arquivoNome: {
      get() {
        return this.doc.nome_original.substr(
          0,
          this.doc.nome_original.length - this.arquivoExtensao.length
        );
      },
      set(val) {
        this.doc.nome_original = val + this.arquivoExtensao;
      },
    },
    arquivoMaxLength() {
      return 255 - this.arquivoExtensao.length;
    },
    doc: {
      get() {
        return this.$store.state.documento.docAtivo;
      },
      set(doc) {
        this.$store.commit("documento/editar", doc);
      },
    },
    disabled() {
      return !(
        (this.arquivo || this.doc.id) &&
        this.doc.registro.length > 0 &&
        this.doc.nome_original.length > this.arquivoExtensao.length &&
        this.arquivoErrors.length === 0
      );
    },
    dataValidade: {
      get() {
        if (!this.doc.data_validade) return "";
        return this.doc.data_validade
          .split("-")
          .reverse()
          .join("/");
      },
      set(val) {
        this.doc.data_validade = val || "";
      },
    },
    ...mapState({
      tiposPermitidos: (state) => state.documento.tiposPermitidos,
    }),
  },
  watch: {
    doc(val) {
      if (!this.tipoDocumento && val) {
        this.tipoDocumento = val.tipo_documento;
      }
    },
    tipoDocumento() {
      this.arquivo = null;
    },
    arquivo(arq) {
      if (arq && this.arquivoErrors.length === 0) {
        this.doc.nome_original = arq.name;
      }
    },
  },
  mounted() {
    this.$store.dispatch("documento/listarTiposPermitidos", this.urlBase);
  },
  methods: {
    strTipos(tipo) {
      return tipo.tipos_permitidos
        .map((t) => {
          switch (t) {
            case "imagem":
              return "Imagens";
            case "pdf":
              return "PDF";
            case "excel":
              return "Planilhas Excel";
            case "word":
              return "Documento Word";
            case "audio":
              return "Áudio MP3";
          }
        })
        .join(", ");
    },
    tamanhoMaximo(tipo) {
      return `Tamanho máximo ${tipo.tamanho_maximo} MB`;
    },
    salvar() {
      if (this.doc.id) {
        this.doc.editar = true;
      } else {
        this.doc.novo = true;
        this.doc.arquivo = this.arquivo;
        this.doc.tipo_documento = this.tipoDocumento;
      }
      if (this.doc.data_validade != "") {
        this.doc.dias_vencimento = moment(
          this.doc.data_validade + " 23:59:59"
        ).diff(moment(), "days");
      }
      this.$emit("change", this.doc);
      this.dialog = false;
    },
  },
};
</script>
